import request from '../request';

function query(q) {
  return request({
    url: `/studyYear/findAll`,
    method: 'get',
    params:q
  });
}

function showY(id) {
  return request({
    url: `/studyYear/show/${id}`,
    method: 'get',
  });
}

function getStudyClass() {
  return request({
    url: `/studyClass/findAll`,
    method: 'get'
  });
}

function add(params) {
  return request({
    url: '/studyYear/add',
    method: 'post',
    data: params
  });
}

function deleteOne(id) {
  return request({
    url: `/studyYear/delete/${id}`,
    method: 'delete'
  });
}

function show(q) {
  return request({
    url: `/studyPerson/show`,
    params:q,
    method: 'get'
  });
}

function deletePerson(id,params) {
  return request({
    url: `/studyPerson/deletePerson/${id}`,
    method: 'delete',
    data: params
  });
}

function upCheck(year,params) {
  return request({
    url: `/studyYear/upCheck/${year}`,
    method: 'post',
    data: params
  });
}

function studyYearUp(year,params) {
  return request({
    url: `/studyYear/studyYearUp/${year}`,
    method: 'post',
    data: params
  });
}

function findPerson(q) {
  return request({
    url: `/studyPerson/findPerson`,
    method: 'get',
    params:q
  });
}

function addPerson(id,params) {
  return request({
    url: `/studyPerson/addPerson/${id}`,
    method: 'post',
    data: params
  });
}

function getYear() {
  return request({
    url: `/studyYear/getYear`,
    method: 'get',
  });
}

function findSetUp(q) {
  return request({
    url: `/studyYear/findSetUp`,
    method: 'get',
    params:{id:q},
  });
}

function findAllSetUpSeq(q) {
  return request({
    url: `/studyYear/findAllSetUpSeq`,
    method: 'get',
    params:{id:q},
  });
}

function updateSetUp(id,params) {
  return request({
    url: `/studyYear/updateSetUp/${id}`,
    method: 'post',
    data: params
  });
}

function mothballLog(id) {
  return request({
    url: `/studyYear/mothballLog/${id}`,
    method: 'get',
  });
}

function mothballType(id) {
  return request({
    url: `/studyYear/mothballType/${id}`,
    method: 'get',
  });
}

function mothball(id,params) {
  return request({
    url: `/studyYear/mothball/${id}`,
    method: 'post',
    data: params
  });
}

function mothballCheck(id) {
  return request({
    url: `/studyYear/mothballCheck/${id}`,
    method: 'get'
  });
}

function resetPoints(id) {
  return request({
    url: `/studyYear/resetPoints/${id}`,
    method: 'get'
  });
}

function transcriptCheck(id,ids) {
  return request({
    url: `/pdf/transcriptCheck/${id}/${ids}`,
    method: 'get'
  });
}
function transcript(id,ids) {
  return request({
    url: `/pdf/transcript/${id}/${ids}`,
    method: 'get'
  });
}


export default {
  query,
  getStudyClass,
  add,
  deleteOne,
  show,
  deletePerson,
  upCheck,
  studyYearUp,
  findPerson,
  addPerson,
  getYear,
  findSetUp,
  updateSetUp,
  findAllSetUpSeq,
  mothballLog,
  mothball,
  mothballType,
  showY,
  mothballCheck,
  resetPoints,
  transcript,
  transcriptCheck
};